<template>
  <div id="">
    <div class="check_btn_box">
      <span><i>{{ multiple }}</i>{{ $t('enum.selected') }}</span>
      <div class="check_btn" :class="multiple > 0 ? 'on' : ''" @click="MessageBox('Read')">{{ $t('button.haveRead') }}</div>
      <div v-if="showType != 'scheduled'" class="check_btn" :class="multiple > 0 ? 'on' : ''" @click="MessageBox('Delete')">{{ $t('button.delete') }}</div>
    </div>
    <el-table ref="multipleTable" :data="list" class="table_box table_msg" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="30" class-name="all_check table-check"></el-table-column>
      <el-table-column :label="$t('enum.state')" align="left" prop="State" width="100">
        <template slot-scope="scope">
          <span :class="scope.row.IsRead ? 'text_gray' : 'text_red'">{{ scope.row.IsRead ?  $t('button.haveRead')  : $t('button.unread') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('enum.title')" align="left" width="200">
        <template slot-scope="scope">
          <span class="line_txt1">{{ scope.row.Title }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('enum.information')" align="left">
        <template slot-scope="scope">
          <div class="com_box">
            <p class="line_txt1">{{ $store.getters.setTitle(scope.row.Body) }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('enum.createTime')" align="left" width="200">
        <template slot-scope="scope">
          <span class="">{{ $store.getters.separatedTime(scope.row.CreateDate, 'cut')[0] }}<br />{{ $store.getters.separatedTime(scope.row.CreateDate, 'cut')[1] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('enum.operate')" align="left" class-name="all_operate" width="160" fixed="right">
        <template slot-scope="scope">
          <div class="" @click="linkTo(scope.row.SendType, scope.row)">
            <span class="hover underline">
              {{ $t('enum.viewDetails') }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <dialog-offer v-if="OfferShow" ref="DialogOffer" :OfferTitle="OfferTitle" :OfferList="OfferList" @OfferBox="OfferBox" @DialogSwitch="DialogSwitch">
    </dialog-offer>

    <!-- Messages From Card Hobby -->
    <el-dialog title="From Card Hobby" :visible.sync="MsgInfoShow" width="480px">
      <div class="dialog_box">
        <div class="card-detail">
          <div class="dialog-row card-block">
            <div class="v-title text_gray">State:</div>
            <div class="v-val">{{ MsgInfo.IsRead ? 'Have read' : 'Unread' }}</div>
          </div>
          <div class="dialog-row">
            <div class="v-title text_gray">Title:</div>
            <div class="v-val">{{ MsgInfo.Title }}</div>
          </div>
          <div class="dialog-row">
            <div class="v-title text_gray">Information:</div>
            <!-- <div class="v-val" >{{ $store.getters.setTitle(MsgInfo.ContentDesc||MsgInfo.Body, 'all') }}</div> -->
            <div class="v-val" v-html="$store.getters.setTitle(MsgInfo.ContentDesc||MsgInfo.Body, 'all')"></div>
          </div>
          <div class="dialog-row">
            <div class="v-title text_gray">Create Time:</div>
            <div class="v-val">{{ $store.getters.getTime(MsgInfo.CreateDate) }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="DialogSwitch('MsgFromCardHobby')">Done</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import DialogOffer from '@/components/dialog/dialog-offer'
export default {
  name: 'watchlistcheck',
  data() {
    return {
      OfferShow: false,//DialogOffer
      OfferList: [],
      OfferTitle: '',
      MsgInfoShow: false,
      MsgInfo: {},
      multiple: 0,
      multipleSelection: [],

    }
  },
  props: {
    list: {},
    showType: String,
  },
  computed: {
  },
  mounted() {

  },
  components: { DialogOffer },
  methods: {
    linkTo(SendType, obj) {
      /** SendType: 
       * 启动客户端 = 0, 订单详情 = 1, 卡片仓库 = 2, 卡片详情页 = 3, 
        议价详情页 = 4, 竞拍详情页 = 5, 组队详情页 = 6, 
        充值 = 7, 消息详情 = 8, 维权详情 = 9
      **/
      let that = this;
      let link = "/";
      switch (SendType) {
        case 0: //卡片详情页 弹框当前行信息
          that.MsgInfo = obj;
          that.MsgInfoShow = true;
          break;
        case 1: //订单详情 跳转页面
          link = `/#/orders/detail?id=${obj.RelationID}`;
          window.open(link);
          break;
        case 3: //卡片详情页 弹框当前行信息
          // link = `/`;
          that.MsgInfo = obj;
          that.MsgInfoShow = true;
          break;
        case 4: //议价详情页 议价列表-议价详细- 弹框
          // link = `/#/commodity/Offer`;
          that.OfferBox('OfferHistory', obj)
          break;
        case 5: //竞拍详情页 跳转页面
          window.open(process.env.VUE_APP_CARD_URL + `/#/carddetails/${obj.RelationID}`);
          break;
        case 9: //维权详情
          // link = `/#/orders`;          
          that.OfferBox('Processing', obj);
          break;
        default:
          that.MsgInfo = obj;
          that.MsgInfoShow = true;
          break;
      }
      if (!obj.IsRead) {
        that.$post('SetRead', { id: obj.ID })//标记消息已读
          .then((res) => {
            if (res.result) {
              // console.log(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.multiple = this.multipleSelection.length
      console.log('multipleSelection', this.multipleSelection)
    },
    // 删除弹框
    MessageBox(val, obj) {
      let that = this;
      var data = [];
      let title = val == 'Read' ? 'Read' : 'Delete';
      let msg = '';
      if (obj == undefined) {
        data = this.multipleSelection;
        if (val == 'Read') {
          msg = '<div class="p_txt">Do you want to Read right now for ' + data.length + ' messages?</div>';
        } else {
          msg = '<div class="p_txt">Do you want to delete these ' + data.length + ' messages?</div>';
        }
      } else {
        data.push(obj);
        if (val == 'Read') {
          msg = '<div class="p_txt">Do you want to Read right now?</div>';
        } else {
          msg = '<div class="p_txt">Do you want to delete this message?</div>';
        }
      }
      if (data.length > 0) {
        // console.log(data);
        let params = '', ids = [];
        data.map((obj, k) => { let d = k == 0 ? '?' : '&'; params += `${d}Ids=${obj.ID}`; ids.push(obj.ID); });
        this.$confirm(msg, title, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then(() => {
          let api = val == 'Read' ? 'SetAllRead' : 'DeleteMessgaes';// 标记全部消息已读/删除消息
          that.$post(api, { Ids: ids })
            .then((res) => {
              console.log("axios-res:", api, res);
              that.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              that.$store.dispatch("msgCounts");//头部总未读数
              that.$emit('getData', '', '', "NotificationCount");//各消息未读数
              that.$emit('getData');//刷新消息列表
            })
            .catch((err) => {
              console.log(err);
            });

          // No
        }).catch(() => {
          // Yes    
        });
      }
    },
    OfferBox(type, obj) {
      /* Offer: ToBeAnswered/Answer、 OfferHistory 议价 */
      let that = this;
      that.OfferShow = true;
      switch (type) {
        case 'OfferHistory'://议价历史
          that.OfferTitle = that.$t('enum.viewOfferHistory');
          let CardInfo = {};
          that.$get('BargainIndex', `?CommodityID=${obj.RelationID}&memberId=${obj.CreateUser}`, 'BuyerId')
            .then((res) => {
              if (res.result) {
                that.OfferList = res.data;
              } else {
                that.OfferList = [];
              }
            })
            .catch((err) => {
              console.log(err);
            });
          that.$get('DetailCommodity', `?CommodityID=${obj.RelationID}`)//获取商品详情
            .then((res) => {
              if (res.result) {
                that.$refs.DialogOffer.CardInfo = res.data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case 'Processing':
          /* 维权列表 */
          that.$get('GetSafeRights', `?orderId=${obj.RelationID}&pageIndex=1&pageSize=999&applyType=0`)
            .then((res) => {
              if (res.result) {
                let _data = res.data;
                that.$get('OrderDetail', `?OrderID=${obj.RelationID}`)//订单详情
                  .then((ress) => {
                    that.OfferShow = true;
                    setTimeout(() => {
                      that.OfferTitle = _data.SRStatus == 1 ? 'Processing' : 'Processed';
                      that.$refs.DialogOffer.CardInfo = _data;
                      that.$refs.DialogOffer.ID = obj.RelationID || obj.ID;//维权详细获取订单ID
                      if (ress.result) {
                        that.$refs.DialogOffer.CardInfo['OrderDetail'] = ress.data;
                      }
                      that.$refs.DialogOffer.dialogType = type;
                      that.$refs.DialogOffer.OfferShow = true;
                    }, 200)
                  })
                //标记消息已读
                // console.log(res.msg);
                //that.OfferBox('OfferEquity', obj)
              }
            })
            .catch((err) => {
              console.log(err);
            });
          that.OfferList = [];
        default:
          break;
      }
      setTimeout(() => {
        that.$refs.DialogOffer.OfferShow = true;
        that.$refs.DialogOffer.dialogType = type;
      }, 100)
    },
    setOfferTitle(val) {
      this.OfferTitle = val || 'Detail';
    },
    // 关闭 维权、From Card Hobby 弹框
    DialogSwitch(dialog) {
      /* dialog Close */
      let that = this;
      switch (dialog) {
        case 'DialogOffer':
          that.$refs.DialogOffer.OfferShow = false;
          that.OfferList = [];
          break;
        case 'MsgFromCardHobby':
          that.MsgInfo = {};
          that.MsgInfoShow = false;
          break;
        default:
          break;
      }
      that.OfferShow = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table_box {
  width: 100%;
}

/deep/.table_msg.el-table .el-table__cell {
  padding: 6px 0;
}

/deep/.table_msg.el-table .cell {
  line-height: 18px;
}

.like_img {
  margin-right: 12px;
}

.com_box {
  display: flex;
}

.com_box p {
  width: 252px;
}

.scheduled p {
  width: 130px;
}

.check_btn_box {
  display: flex;
  line-height: 30px;
  padding: 20px 0;
}

.check_btn_box i {
  color: #5f6dae;
  margin-right: 2px;
}

.check_btn {
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  color: #c8c8c8;
  border-radius: 4px;
  margin-left: 12px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
}

.check_btn.on {
  color: #5f6dae;
  border-color: #5f6dae;
}

.all_operate div {
  cursor: pointer;
}

.text_gray_c8 {
  color: #c8c8cc;
}

.time_width {
  width: 90px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/tablemessages.vue